// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hghwK","type":"styles_type__XNWNt","choices":"styles_choices__2sA1B"};